import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChat = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.926 16.708a1.5 1.5 0 0 1 .155 1.358l-.747 1.988 3.015-.545a1.5 1.5 0 0 1 .925.128A8.5 8.5 0 1 0 12.001 3.5V2a10 10 0 1 1-4.385 18.985L2 22l1.677-4.462A10 10 0 0 1 12 2l.001 1.5a8.501 8.501 0 0 0-7.075 13.208"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChat;
